module.exports = __webpack_public_path__ + "static/media/blog.bc1128b5.svg";